import React from "react";

import { Link } from "react-router-dom";

function MainNextPage(props) {
  return (
    <div>
      <div className="album py-5 bg-light ">
        <div className="container">
          <div className="row row-cols-10 row-cols-sm-10 row-cols-md-10 ">
            <h6 className="text-center fw-bold pb-4 pt-3 ">
              SALES AND BEST DEALS
            </h6>
            <Link className="banner4" to="/search/name">
              <img src="/img/a.jpg" className=" align-self-center" alt="..." />
              <img src="/img/b.jpg" className=" align-self-center" alt="..." />
            </Link>
          </div>

          <div className="pt-5">
            <h6 className="text-center fw-bold pb-4 pt-4">SHOP BY BRAND</h6>
            <div className="row row-cols-2 row-cols-sm-2 row-cols-md-4 g-2 pb-4 brand">
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/01_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/01_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/02_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/02_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/04_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/04_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/06_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/06_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/07_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/07_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/08_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/08_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/09_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/09_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm  brandimage ">
                  <div className="picture1 text-center">
                    <img
                      src="/img/12_gray.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                  <div className="picture2 text-center">
                    <img
                      src="/img/12_color.png"
                      className="card-img-top  img-responsiv"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainNextPage;
